import React from 'react'
import BaseIcon from 'react-icon-base'

const MY = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 21 15" {...props}>
    <title>MY</title>
    <defs>
      <rect id="a" width="21" height="15" rx="2" />
      <rect id="c" width="20" height="14" x=".5" y=".5" rx="2" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#00297B" xlinkHref="#a" />
      <g fillRule="nonzero" mask="url(#b)">
        <path fill="#CC0001" d="M.05.05h29.801v14.901H.05z" />
        <path
          fill="#FFF"
          d="M.05 13.886h29.801v1.064H.05zM.05 11.757h29.801v1.064H.05zM.05 9.629h29.801v1.064H.05zM.05 7.5h29.801v1.064H.05zM.05 5.371h29.801v1.064H.05zM.05 3.243h29.801v1.064H.05zM.05 1.114h29.801v1.064H.05z"
        />
        <path fill="#010066" d="M.05.05h10.901v8.515H.05z" />
        <path
          fill="#FC0"
          d="M4.18 1.114A3.2 3.2 0 0 0 .977 4.307 3.2 3.2 0 0 0 4.18 7.5c.639 0 1.234-.187 1.734-.509a2.837 2.837 0 0 1-3.77-2.676 2.837 2.837 0 0 1 2.841-2.83c.347 0 .679.061.986.175a3.195 3.195 0 0 0-1.79-.546z"
        />
        <path
          fill="#FC0"
          d="M9.493 5.97l-1.35-.705.4 1.441-.903-1.205-.282 1.467L7.081 5.5l-.906 1.203.404-1.44-1.352.7L6.23 4.836l-1.53.06 1.407-.59-1.404-.595 1.529.063-1-1.13 1.349.705-.4-1.441.903 1.205.282-1.467.277 1.468.906-1.203-.403 1.44 1.351-.7-1.004 1.127 1.53-.06-1.406.59 1.404.595-1.53-.063z"
        />
      </g>
      <use stroke="#2F343A" strokeOpacity=".157" xlinkHref="#c" />
    </g>
  </BaseIcon>
)

export default MY
